import Vue from 'vue'
import VueAMap from 'vue-amap'

Vue.use(VueAMap)
Vue.prototype.$key = '9b0bf0315fca38d1f5f864c7e1d3c42d';
VueAMap.initAMapApiLoader({
    key: '9b0bf0315fca38d1f5f864c7e1d3c42d',
    plugin: ['AMap.Geolocation', 'AMap.Geocoder', 'AMap.CitySearch'],
    sdk: '1.4.4'
})

// export default VueAMap


//////////////////
// WEBPACK FOOTER
// ./map/index.js
// module id = GYz9
// module chunks = 45